import React from 'react';
import styles from './index.less';
import ToTopBtnStore from './store';
import wrapStore from '@src/utils/wrap-store';
import cx from 'classnames';

const ToTopBtn = ({ store, className }) => {

  store.use();

  return (
    <div
      className={cx(styles.toTopBtn, className)}
      onClick={store.scrollToTop}
    />
  );
};

export default wrapStore(ToTopBtn, ToTopBtnStore);